module.exports = __webpack_public_path__ + "img/target-4.36be07f8.png";